export default [
  {
    path: 'live-view',
    name: 'website.live-view',
    component: () => import('@/views/website/live-view'),
  },
];
